import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import _ from 'lodash';

const makeOptions = (types, selected) =>
  _.filter(
    _.map(types, type => {
      const option = _.isObject(type)
        ? { value: type.code || type.id, label: type.name || type.code }
        : { value: type, label: type };

      if (_.indexOf(selected, option.value) > -1) {
        return null;
      }

      return option;
    }),
  );

const FilterMultiSelect = props => (
  <Select
    name={props.name}
    onChange={option => props.onChange(option.value)}
    options={makeOptions(props.types, props.selected)}
    placeholder={props.placeholder}
  />
);

FilterMultiSelect.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  selected: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  types: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onChange: PropTypes.func,
};

export default FilterMultiSelect;
